<template lang="pug">
md-dialog#general-form-wrapper(:md-click-outside-to-close='false', :ref='dialogRef', @close='handleDialogClose')
    md-dialog-title Rental price
    md-dialog-content(v-if='openDialog')
        rental-pricing-form(@price-selected="handlePriceSelected", :price='price')
        playlist-selector(:multiple='true', @input='selectedPlaylist', :value='mediaItemSelected.playlists')
        md-chips#input-chips(v-model='tags' :md-max='15', md-input-placeholder='Tags...')
            template(slot-scope='chip')
                span {{ chip.value }}
        div
            div.data-container
                p.md-headline Ad Breaks
                p.video-duration Video duration: {{ duration }}
            media-items-roku-ad-breaks(:formSubmitted='formSubmitted', :mediaItem='mediaItemSelected')
        Loader(:loading='loading', :size='50')
        div(v-if='!loading').btn-container
            md-button.md-primary.md-raised(@click='saveData()') Save
            md-button.cancel-btn.md-raised(@click='closeDialog()') Cancel
</template>

<script>
import mediaItemService from '../../services/mediaItemService';
import uuid from 'uuid';
import RentalPricingForm from '../forms/RentalPricingForm.vue';
import MediaItemsRokuAdBreaks from './MediaItemsRokuAdBreaks.vue';
import Loader from '../Loader.vue';
import PlaylistSelector from '../playlist/PlaylistSelector.vue';

export default {
    components: {
        RentalPricingForm,
        MediaItemsRokuAdBreaks,
        Loader,
        PlaylistSelector
    },
    props: {
        playlistsMap: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            dialogRef: uuid.v4(),
            tags: [],
            price: null,
            distributionId: null,
            mediaItemSelected: {},
            openDialog: false,
            duration: null,
            formSubmitted: false,
            loading: false,
            playlistNames: ''
        };
    },
    methods: {
        showAlertToast(text, icon) {
            this.$swal({
                text: text,
                position: "bottom-left",
                icon: icon,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                showConfirmButton: false,
            });
        },
        closeDialog() {
            this.openDialog = false;
            this.clearDialogData();
            const ref = this.dialogRef;
            this.$refs[ref].close();
            this.$emit('closed');
        },
        handleDialogClose() {
            this.clearDialogData()
        },
        openRentalPriceDialog(mediaItem) {
            this.clearDialogData();
            this.openDialog = true;
            this.mediaItemSelected = mediaItem;
            this.mediaItemSelected.playlists = this.getDistributionPlaylistIds(mediaItem);
            this.duration = this.formatDuration(mediaItem.videoDuration);
            this.price = (mediaItem && mediaItem.prices && mediaItem.prices[0] && mediaItem.prices[0].price) ? mediaItem.prices[0].price.amount : null;
            this.tags = mediaItem.tags ? mediaItem.tags : [];
            this.playlistNames = this.getPlaylistNames(mediaItem);
            const ref = this.dialogRef;
            this.$refs[ref].open();
        },
        saveData() {
            this.loading = true;
            this.formSubmitted = true;
            this.mediaItemSelected.tags = this.tags;
            if(!this.mediaItemSelected.prices) { this.mediaItemSelected.prices = [] }
            if(this.price) { this.mediaItemSelected.prices[0] = this.price }
            console.log('mediaItemSelected', this.mediaItemSelected.playlists);
            mediaItemService.update(this.mediaItemSelected._id, this.mediaItemSelected)
            .then(() => {
                this.$emit('price-updated')
                this.showAlertToast('Video updated successfully', 'success');
            })
            .catch((error) => {
                this.$emit('price-updated')
                this.showAlertToast('Video could not be updated. Please, try again late', 'error');
            })
            .finally(() => {
                this.loading = false;
                this.formSubmitted = false;
                this.closeDialog();
            });
        },
        clearDialogData() {
            this.tags = [],
            this.price = null,
            this.distributionId = null,
            this.mediaItemSelected = {},
            this.openDialog = false,
            this.duration = null,
            this.formSubmitted = false,
            this.playlistNames = ''
        },
        handlePriceSelected(option) {
            if(option) {
                this.price = option
            }
        },
        selectedPlaylist(playlist) {
            this.mediaItemSelected.playlists = playlist;
            console.log('mediaItemSelected', this.mediaItemSelected.playlists);
        },
        formatDuration(seconds) {
        const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
        const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
        const s = Math.floor(seconds % 60).toString().padStart(2, '0');
        return `${h}:${m}:${s}`;
        },
        getDistributionPlaylistIds(mediaItem) {
            const distributions = (mediaItem && (mediaItem.distributions || mediaItem.distribution)) || [];
            if (!Array.isArray(distributions) || distributions.length === 0) {
                return [];
            }

            const ids = [];
            distributions.forEach((distribution) => {
                const playlistRef = distribution && distribution.source && distribution.source.playlist;
                if (!playlistRef) {
                    return;
                }

                if (Array.isArray(playlistRef)) {
                    playlistRef.forEach((entry) => {
                        if (typeof entry === 'string') {
                            ids.push(entry);
                        } else if (entry && entry._id) {
                            ids.push(entry._id);
                        }
                    });
                    return;
                }

                if (typeof playlistRef === 'string') {
                    ids.push(playlistRef);
                    return;
                }

                if (playlistRef && playlistRef._id) {
                    ids.push(playlistRef._id);
                }
            });

            return Array.from(new Set(ids));
        },
        getPlaylistNames(mediaItem) {
            const playlistIds = this.getDistributionPlaylistIds(mediaItem);
            if (playlistIds.length === 0) {
                return '';
            }

            const playlistNames = playlistIds.map((playlistId) => this.playlistsMap[playlistId]).filter(Boolean);
            return playlistNames.length > 0 ? playlistNames.join(', ') : '';
        }
    },
};
</script>

<style lang="scss" scoped>
.cancel-btn {
    background-color: #d33 !important;
    color: white !important;
    font-size: 1.1em;
}

.cancel-btn :hover {
    background-color: #d33 !important;
}

.btn-container {
    display: flex;
    justify-content: end;
    margin-top: 20px;
}

.data-container {
    display: flex;
    justify-content: start;
    gap: 0 20px;
}

.video-duration {
    font-size: 0.85rem;
    color: #757575;
    font-weight: normal;
    margin-top: 8px;
}

.playlists-container {
    margin: 15px 0;
    padding: 10px 0;
    border-top: 1px solid rgba(153, 155, 155, 0.2);
}

.playlists-container .md-subheading {
    margin-bottom: 5px;
    font-weight: 600;
}

.playlist-names {
    font-size: 0.9rem;
    color: #616161;
    margin: 0;
    line-height: 1.5;
}

</style>



// WEBPACK FOOTER //
// src/shared-components/mediaItem/RentalPriceDialog.vue